<template lang="pug">
.order-pack__row(:class="rowClass")
  .order-pack__cell.order-pack__col-check(v-if="showCheck" @click.stop="")
    shCheckbox(
      :value="selected"
      @input="$emit('select', $event)"
      :icon-color="iconColor"
      :icon-size="iconSize"
    )
  .order-pack__cell.order-pack__col-number
    span.tag.uppercase(
      :class="[`bg-${item.brand}`, { 'order-pack__id-link': linkOrder && !isDetail }]"
      @click.stop="onOrderClick"
    ) {{ item.order }}
  .order-pack__cell.order-pack__col-status
    .tag.order-pack__status-label(:style="statusStyle") {{ statusLabel }}
    .tag.order-pack__quantity {{ productQuantity }}
  .order-pack__cell.order-pack__col-name.capitalize {{ name }}
  .order-pack__cell.order-pack__col-location.capitalize {{ location }}
  .order-pack__cell.order-pack__col-date {{ dateLabel }}
  .order-pack__cell.order-pack__col-remit(v-if="!hideRemitColumn" @click.stop="")
    .order-pack__remit-cell
      span.uppercase(v-if="changeLabel !== null") {{ changeLabel }}
      RemitDataIcon(
        v-if="showRemit && !remitInActionsColumn"
        :record="item"
        :icon-color="iconColor"
        :icon-size="iconSize"
      )
      button.order-pack__print-btn(
        v-if="isDetail && showPrint"
        type="button"
        @click="$emit('print')"
        aria-label="Imprimir"
      )
        span.material-symbols-outlined(:style="printIconStyle") print
  .order-pack__cell.order-pack__col-novelty(v-if="resolvedNoveltyTags.length")
    .order-pack__novelty-tags
      button.order-pack__novelty-tag.capitalize(
        v-for="tag in resolvedNoveltyTags"
        :key="tag.type"
        type="button"
        :class="tag.class"
        @click.stop="$emit('novelty-tag', tag.type)"
      )
        span.order-pack__novelty-tag-label {{ tag.label }}
        span.order-pack__novelty-tag-count(v-if="tag.count") {{ tag.count }}
  .order-pack__cell.order-pack__col-novelty-package(v-if="showPackageColumn" @click.stop="")
    slot(name="package")
  .order-pack__cell.order-pack__col-novelty-quote(v-if="showQuoteColumn") {{ quoteLabel }}
  .order-pack__cell.order-pack__col-novelty-actions(v-if="showNoveltyActions" @click.stop="")
    slot(name="novelty-actions")
  .order-pack__cell.order-pack__col-novelty-close(v-if="showNoveltyClose" @click.stop="")
    slot(name="novelty-close")
  .order-pack__cell.order-pack__col-message(
    :class="{ 'order-pack__col-message--detail': isDetail }"
    @click.stop=""
  )
    slot(name="message")
</template>

<script>
import shCheckbox from '@/components/elements/Checkbox'
import RemitDataIcon from '@/components/elements/remit/RemitDataIcon.vue'
import { recordProductQuantity } from '@/helpers/productQuantity'

export default {
  name: 'PackListOrderRow',

  components: { shCheckbox, RemitDataIcon },

  props: {
    item: { type: Object, required: true },
    isDetail: { type: Boolean, default: false },
    showCheck: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    linkOrder: { type: Boolean, default: false },
    name: { type: String, default: '' },
    location: { type: String, default: '' },
    dateLabel: { type: String, default: '' },
    statusLabel: { type: String, default: '' },
    statusStyle: { type: Object, default: () => ({}) },
    noveltyTypeLabel: { type: String, default: '' },
    noveltyTypeClass: { type: String, default: '' },
    noveltyTags: { type: Array, default: () => [] },
    showRemit: { type: Boolean, default: true },
    hideRemitColumn: { type: Boolean, default: false },
    remitInActionsColumn: { type: Boolean, default: false },
    showPackageColumn: { type: Boolean, default: false },
    showQuoteColumn: { type: Boolean, default: false },
    quoteLabel: { type: String, default: '' },
    showNoveltyActions: { type: Boolean, default: false },
    showNoveltyClose: { type: Boolean, default: false },
    changeLabel: { type: String, default: null },
    iconColor: { type: String, default: 'var(--color-placeholder)' },
    iconSize: { type: String, default: '1.75rem' },
    showPrint: { type: Boolean, default: false },
    printIconStyle: { type: Object, default: () => ({}) }
  },

  computed: {
    rowClass () {
      return {
        'order-pack__row--detail': this.isDetail,
        'is-selected': !this.isDetail && this.selected
      }
    },

    productQuantity () {
      return recordProductQuantity(this.item)
    },

    resolvedNoveltyTags () {
      if (this.noveltyTags && this.noveltyTags.length) return this.noveltyTags

      if (!this.noveltyTypeLabel) return []

      return [{
        type: this.noveltyTypeClass === 'is-product' ? 'product' : 'data',
        label: this.noveltyTypeLabel,
        class: this.noveltyTypeClass
      }]
    }
  },

  methods: {
    onOrderClick () {
      if (this.linkOrder) this.$emit('open-order', this.item.order)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/order/pack/PackListOrderRow.vue